export enum Brand {
  FLEXPAY = 'FLEXPAY',
  UPLIFT = 'UPLIFT',
}

export enum PaymentOption {
  BANK_ACCOUNT = 'bank-account',
  CREDIT = 'credit',
  DEBIT = 'debit',
}

export enum AcceptFormNames {
  AUTOPAY = 'autopay',
  CARD_INFO_NUMBER = 'card-info-number',
  CARD_INFO_EXPIRATION = 'card-info-expiration',
  CARD_INFO_CCV = 'card-info-ccv',
  BILLING_ZIP = 'billing-zip',
  CARD_INFO_NAME = 'card-info-name',
  FULL_SSN = 'full-ssn',
}

export enum VerifyFormNames {
  MOBILE_VERIFICATION_CODE = 'mobile-verification-code',
}

export enum FullSSNFormNames {
  FULL_SSN = 'full-ssn',
}

export enum DateFormat {
  MM_DD_YYYY = 'mmddyyy',
  DD_MM_YYYY = 'ddmmyyyy',
  YYYY_MM_DD = 'yyyymmdd',
}

export enum InputGroupWidth {
  HALF = 'half',
  HALF_DESKTOP = 'half-desktop',
  THIRD_DESKTOP = 'third-desktop',
}

export enum AlertNames {
  ERROR = 'error',
  NOTICE = 'notice',
  WARNING = 'warning',
  DISCLAIMER = 'disclaimer',
}

export enum Keys {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  ESC = 'Esc',
  TAB = 'Tab',
  SPACEBAR = 'Spacebar',
  SPACE = ' ',
}

export enum QuebecOption {
  MONTHLY_HOUSING_COST = 'monthly_housing_cost',
  PRIMARY_INCOME_SOURCE = 'primary_income_source',
  OCCUPATION = 'occupation',
  EMPLOYMENT_DURATION = 'employment_duration',
}
